import api from "./api";

export const fetchAgentAnalyticsDashboard = async () => {
    try {
        const response = await api.get(
            "/agent-analytics-management/dashboard"
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent dashboard analytics.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent dashboard analytics.",
        };
    }
};

export const fetchAgentProgrammeStatistics = async () => {
    try {
        const response = await api.get(
            "/agent-analytics-management/programme"
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent programme statistics.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent programme statistics.",
        };
    }
};

export const fetchAgentCertificationStatistics = async () => {
    try {
        const response = await api.get(
            "/agent-analytics-management/certification"
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent certification statistics.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent certification statistics.",
        };
    }
};

export const fetchAgentOperationalStatistics = async () => {
    try {
        const response = await api.get(
            "/agent-analytics-management/operations"
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent operational statistics.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent operational statistics.",
        };
    }
};

export const fetchTopPerformingAgents = async (
    limit = 10
) => {
    try {
        const response = await api.get(
            "/agent-analytics-management/top-performing-agents",
            {
                params: {
                    limit,
                },
            }
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve top performing agents.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve top performing agents.",
        };
    }
};

export const fetchAgentPerformance = async () => {
    try {
        const response = await api.get(
            "/agent-analytics-management/agent-performance"
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent performance.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent performance.",
        };
    }
};

export const fetchAgentCustomerSatisfaction = async () => {
    try {
        const response = await api.get(
            "/agent-analytics-management/customer-satisfaction"
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
                message: response.data.message,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent customer satisfaction.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent customer satisfaction.",
        };
    }
};